import React from 'react';
import { IMaskInput } from 'react-imask';
import { InputWrapper, FormWrapper } from './Wrappers';
import { genericMemo } from './Types';

const dateValidationRegex = /^\d{4}\-\d{2}\-\d{2}$/;

export function isValidDate(strDate: string) {
  if (strDate === '' || !dateValidationRegex.test(strDate)) return false;
  const [y, m, d] = strDate.split('-').map(n => parseInt(n));
  return m === new Date(y, m - 1, d).getMonth() + 1 && 1900 <= y && y <= 2099;
}

function DateInputRaw({onChange, value, ...props}: {value?: string, onChange?: (value: string) => void}) {
  return (
    <IMaskInput
      value={value}
      {...props}
      mask='0000-00-00'
      unmask={false}
      onAccept={(value, _mask, event) => {if (event !== undefined && onChange !== undefined) { onChange(value) }}}
    />
  )
}

const DateInput = genericMemo(FormWrapper({Component: InputWrapper(DateInputRaw), validationFunction: isValidDate}))

export default DateInput
